import { ElementAddress, MediaElement } from 'editor/src/store/design/types';

import { RootState } from 'editor/src/store';

import getMediaElement from './getMediaElement';
import getStructureIndexesByElementUuids from './getStructureIndexesByElementUuids';
import isElementInteractable from './isElementInteractable';

/**
 * The elements behind the uuids, or undefined when any of them cannot be moved: it is
 * gone from the design, locked, or personalization-locked where the host does not
 * ignore that lock. A group moves whole or not at all.
 */
const getMovableMediaElements = (
  state: RootState,
  uuids: number[],
): { address: ElementAddress; element: MediaElement }[] | undefined => {
  const targets = getStructureIndexesByElementUuids(state, uuids).flatMap((address) => {
    const element = getMediaElement(state, address);
    return element ? [{ address, element }] : [];
  });
  const allMovable =
    targets.length > 0 &&
    targets.length === uuids.length &&
    targets.every(({ element }) => !element.locked && isElementInteractable(state, element));
  return allMovable ? targets : undefined;
};

export default getMovableMediaElements;
